module.exports = __webpack_public_path__ + "img/Dantam Hair 04.716d82c7.jpg";